import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { globalMenu, footerMsgStore, global } from "@shared/libs/Global";

const Footer = () => {
  const navigate = useNavigate();
  const [elapsedTime, setElapsedTime] = useState<string>("0초");
  const { userInfo } = global();
  const { activeMenuInfo } = globalMenu();
  const { footerMsg } = footerMsgStore();
  const message = activeMenuInfo.cd_menu
    ? footerMsg.get(activeMenuInfo.cd_menu)
    : "";

  useEffect(() => {
    if (!userInfo) {
      return;
    } else {
    }
  }, [userInfo, navigate]);

  if (!userInfo) return null; //  user가 없으면 null 반환

  return (
    <footer className="w-full h-[20px] bg-[rgb(230,230,230)] text-xs text-black flex justify-between items-center px-2">
      {/* Left Section: 알림 영역 */}
      <div className="flex-1 font-bold">{message}</div>

      {/* Right Section: Copyright */}
      <div className="ml-4">
        &copy; 2025-{new Date().getFullYear()} G2sysnet Inc. All rights
        reserved.
      </div>
    </footer>
  );
};

export default Footer;
